import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/icon-error.svg'


const _hoisted_1 = { class: "intro-component-with-signup-form" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Learn to code by watching others"),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, "See how experienced developers solve problems in real-time. Watching scripted tutorials is great, but understanding how developers think is invaluable.")
], -1)
const _hoisted_4 = { class: "sign-up" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card try" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Try it free 7 days"),
      /*#__PURE__*/_createTextVNode(" then $20/mo. thereafter ")
    ])
  ])
], -1)
const _hoisted_6 = { class: "card form" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "controls" }
const _hoisted_9 = { class: "input" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "validation-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Validation Error Icon"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "validation-error" }, "First Name cannot be empty", -1)
const _hoisted_12 = { class: "input" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "validation-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Validation Error Icon"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "validation-error" }, "Last Name cannot be empty", -1)
const _hoisted_15 = { class: "input" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "validation-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Validation Error Icon"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "validation-error" }, "Looks like this is not an email", -1)
const _hoisted_18 = { class: "input" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "validation-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Validation Error Icon"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "validation-error" }, "Password cannot be empty", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "terms" }, [
  /*#__PURE__*/_createTextVNode("By clicking the button, you are agreeing to our "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-link"
  }, "Terms and Services")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["control", {'invalid': _ctx.validation.isValidationEnabled && !_ctx.validation.isFirstNameValid}])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.FirstName) = $event)),
                    ref: "firstName",
                    type: "text",
                    placeholder: "First Name",
                    "aria-placeholder": "First Name"
                  }, null, 512), [
                    [_vModelText, _ctx.model.FirstName]
                  ]),
                  _hoisted_10
                ]),
                _hoisted_11
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["control", {'invalid': _ctx.validation.isValidationEnabled && !_ctx.validation.isLastNameValid}])
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.LastName) = $event)),
                    type: "text",
                    placeholder: "Last Name",
                    "aria-placeholder": "Last Name"
                  }, null, 512), [
                    [_vModelText, _ctx.model.LastName]
                  ]),
                  _hoisted_13
                ]),
                _hoisted_14
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["control", {'invalid': _ctx.validation.isValidationEnabled && !_ctx.validation.isEmailAddressValid}])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.EmailAddress) = $event)),
                    type: "email",
                    placeholder: "Email Address",
                    "aria-placeholder": "Email Address"
                  }, null, 512), [
                    [_vModelText, _ctx.model.EmailAddress]
                  ]),
                  _hoisted_16
                ]),
                _hoisted_17
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["control", {'invalid': _ctx.validation.isValidationEnabled && !_ctx.validation.isPasswordValid}])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.Password) = $event)),
                    type: "password",
                    placeholder: "Password",
                    "aria-placeholder": "Password"
                  }, null, 512), [
                    [_vModelText, _ctx.model.Password]
                  ]),
                  _hoisted_19
                ]),
                _hoisted_20
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.signup && _ctx.signup(...args))),
                type: "button",
                class: "control btn"
              }, "Claim your Free Trial")
            ]),
            _hoisted_21
          ])
        ])
      ])
    ])
  ]))
}